import React, {forwardRef} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
//Navegacion
import {NavLink as RouterLink} from 'react-router-dom';
//Material-UI
//Componentes
import makeStyles from '@material-ui/core/styles/makeStyles';
import ListItem from '@material-ui/core/ListItem';
import Button from '@material-ui/core/Button';
import {colors} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
   nested: {
      paddingLeft: theme.spacing(3)
   },
   item: {
      display: 'flex',
      paddingTop: 0,
      paddingBottom: 0
   },
   button: {
      color: colors.blueGrey[800],
      padding: '10px 8px',
      justifyContent: 'flex-start',
      textTransform: 'none',
      letterSpacing: 0,
      width: '100%',
      fontWeight: theme.typography.fontWeightMedium
   },
   icon: {
      color: theme.palette.icon,
      width: 24,
      height: 24,
      display: 'flex',
      alignItems: 'center',
      marginRight: theme.spacing(1)
   },
   active: {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium,
      '& $icon': {
         color: theme.palette.primary.main
      }
   }
}));

const CustomRouterLink = forwardRef((props, ref) => (
   <div ref={ref} style={{flexGrow: 1}}>
      <RouterLink {...props} />
   </div>
));

function Item(props) {
   const classes = useStyles();
   const {title, icon, href, noAnidado, hidden} = props;
   if (hidden) {
      return null;
   } else {
      return (
         <ListItem className={clsx(classes.item, {[classes.nested]: !noAnidado})} disableGutters>
            <Button
               activeClassName={classes.active}
               className={clsx(classes.button)}
               component={CustomRouterLink}
               to={href}
            >
               <div className={classes.icon}>{icon}</div>
               {title}
            </Button>
         </ListItem>
      );
   }
}

Item.defaultProps = {
   noAnidado: false
};

export default Item;
